/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Santai_S2Inputs */

const en_tut_santai_s2 = /** @type {(inputs: Tut_Santai_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If the room manager enabled it, press **Sapa maskot** to greet the room mascot.`)
};

const id_tut_santai_s2 = /** @type {(inputs: Tut_Santai_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalau pengelola ruang mengaktifkannya, tekan **Sapa maskot** untuk menyapa maskot ruangan.`)
};

/**
* | output |
* | --- |
* | "If the room manager enabled it, press **Sapa maskot** to greet the room mascot." |
*
* @param {Tut_Santai_S2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_santai_s2 = /** @type {((inputs?: Tut_Santai_S2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Santai_S2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_santai_s2(inputs)
	return en_tut_santai_s2(inputs)
});